import { create } from 'zustand';

type LoaderStoreType = {
    label: string;
    showLoader: boolean;
    setShowLoader: (showLoader: boolean, label?: string) => void;
    downloadProgress: any;
    setDownloadProgress: (downloadProgress: any) => void;
};

export const useLoaderStore = create<LoaderStoreType>((set) => ({
    label: '',
    showLoader: false,
    setShowLoader: (showLoader, label) => set({ showLoader, label: showLoader ? label : '', downloadProgress: null }),
    downloadProgress: null,
    setDownloadProgress: (downloadProgress) => set({ downloadProgress }),
}));

export const LoaderStore = useLoaderStore.getState;
